import React, { useState } from 'react';
import './CircleProgressBar.scss';


const CircularProgressBar = ({ sqSize, strokeWidth, percentage}) => {
    // Size of the enclosing square
    // const sqSize = props.sqSize;
    // SVG centers the stroke width on the radius, subtract out so circle fits in square
    const radius = (sqSize - strokeWidth) / 2;
    // Enclose cicle in a circumscribing square
    const viewBox = `0 0 ${sqSize} ${sqSize}`;
    // Arc length at 100% coverage is the circle circumference
    const dashArray = radius * Math.PI * 2;
    // Scale 100% coverage overlay with the actual percent
    const dashOffset = dashArray - dashArray * percentage / 100;

    return (
      <svg
        width={sqSize}
        height={sqSize}
        viewBox={viewBox}>
        <circle
          className="circle-background"
          cx={sqSize / 2}
          cy={sqSize / 2}
          r={radius}
          strokeWidth={`${strokeWidth}px`} />
        <circle
          className="circle-progress"
          cx={sqSize / 2}
          cy={sqSize / 2}
          r={radius}
          strokeWidth={`${strokeWidth}px`}
          // Start progress marker at 12 O'Clock
          transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset
          }} />
        {/*<text*/}
        {/*  className="circle-text"*/}
        {/*  x="50%"*/}
        {/*  y="50%"*/}
        {/*  dy=".3em"*/}
        {/*  textAnchor="middle">*/}
        {/*  {`${this.props.percentage}%`}*/}
        {/*</text>*/}
      </svg>
    );
}


const CircleProgressSVG = ({ strokeWidth = 1, sqSize = 20, total = 0 }) => {
  // const [percentage, setPercentage] = useState(total)
  const [percentage] = useState(total)

  // const handleChangeEvent = (num) => {
  //   setPercentage(num)
  // }

  return (
    // <div>
      <CircularProgressBar
        strokeWidth={strokeWidth}
        sqSize={sqSize}
        percentage={percentage}/>
    //   <div>
    //     <input
    //       id="progressInput"
    //       type="range"
    //       min="0"
    //       max="100"
    //       step="1"
    //       value={percentage}
    //       onChange={(e) => handleChangeEvent(e.target.value)}/>
    //   </div>
    // </div>
  );
}

export default CircleProgressSVG
